import api from "../../Hooks/axiosApi";

/**
 * Sending a text from the CRM.
 *
 * These go through the API, never straight to the SMS provider. The provider's
 * credentials live in the API's app settings, so nothing sensitive is in this
 * bundle and there is one place to rotate them.
 */

export const sendSmsService = (body: { mobile: string; message: string }) => {
    return api.post(`/api/crm/sms/send`, body);
};

export const sendBulkSmsService = (body: { mobiles: string[]; message: string }) => {
    return api.post(`/api/crm/sms/bulk`, body);
};

export const getSmsStatusService = () => {
    return api.get(`/api/crm/sms/status`);
};
